
<div class="modal-dialog confirm-dialog">
  <div class="modal-content">
    <form #deploymentForm="ngForm" (ngSubmit)="save()">
      <div class="modal-header">
        <h4 class="modal-title">Create a Deployment</h4>
        <button class="close" type="button" (click)="cancel()">&times;</button>
      </div>
      <div class="modal-body">
        <error [error]="error"></error>
        <div *ngIf="loading">
          <md-spinner-block></md-spinner-block>
        </div>
        <div *ngIf="!loading">
          <div class="alert alert-info" *ngIf="!availableSites?.length">You cannot create a deploy if you do not have any site unless the multisite checkbox is checked.</div>
          <div class="row">
            <div class="form-group col">
              <label class="required" for="deploymentName">Name:</label>
              <input class="form-control" id="deploymentName" [(ngModel)]="deploymentName" name="deploymentName" maxlength="250" required>
            </div>
          </div>
          <div class="row">
            <div class="form-group col">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" autoLinkToLabel [(ngModel)]="multiSiteDeployment" name="checkMultiSite">
                <label class="form-check-label">Multi-Site Deployment</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col" *ngIf="!multiSiteDeployment &amp;&amp; availableSites?.length">
              <label for="selectedSiteId">Site:</label>
              <ng-select id="selectedSiteId" [(ngModel)]="siteId" name="selectedSiteId" [disabled]="disableSiteSelecting">
                <ng-option *ngFor="let property of availableSites" [value]="property.siteId">{{property.siteName}}</ng-option>
              </ng-select>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" type="submit" [disabled]="(availableSites?.length &amp;&amp; !siteId &amp;&amp; !multiSiteDeployment) || (!multiSiteDeployment &amp;&amp; !availableSites?.length)">Save</button>
        <button class="btn btn-outline-secondary" type="button" (click)="cancel()">Cancel</button>
      </div>
    </form>
  </div>
</div>